export default __webpack_public_path__ + "static/media/icon-comunidad.a0c9fefc.svg";